import React from 'react';
import PropTypes from 'prop-types';

class HiddenFormFields extends React.Component {
  constructor(props) {
    super(props);
    this.generateAllInputs = this.generateAllInputs.bind(this);
  }

  generateAllInputs() {
    return this.props.fieldAttributesArr.map((attr) => {
      let val = attr.value;
      if (val == null) {
        val = '';
      }
      return (
        <input
          type="hidden"
          name={attr.name}
          value={val}
          key={attr.name}
          id={attr.id}
        />
      );
    });
  }

  render() {
    const inputs = this.generateAllInputs();

    return (
      <div>
        {inputs}
      </div>
    );
  }
}

HiddenFormFields.propTypes = {
  fieldAttributesArr: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.any,
    id: PropTypes.string,
  })).isRequired,
};

export default HiddenFormFields;



// WEBPACK FOOTER //
// ./src-react/HiddenFormFields/index.jsx